<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات جایگاه بنر"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="صفحه"
                      label-for="Screen"
                    >
                      <v-select
                        v-model="Form.Screen"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Screen"
                        :clearable="false"
                        :options="enums('Screen')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="نوع"
                      label-for="BannerType"
                    >
                      <v-select
                        v-model="Form.Type"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="BannerType"
                        :clearable="false"
                        :options="enums('BannerType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="تعداد"
                      label-for="Count"
                    >
                      <b-form-input
                        id="Count"
                        v-model="Form.Count"
                        autocomplete="off"
                        type="number"
                        :disabled="Form.Type === 0"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="جایگاه"
                      label-for="Position"
                    >
                      <b-form-input
                        id="Position"
                        v-model="Form.Position"
                        autocomplete="off"
                        type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="مرتب سازی"
                      label-for="Sorting"
                    >
                      <v-select
                        v-model="Form.Sorting"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Sorting"
                        :clearable="false"
                        :options="enums('Sorting')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="آگهی دهنده"
                      label-for="Advertiser"
                    >
                      <v-select
                        v-model="Form.Advertiser"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Advertiser"
                        :multiple="true"
                        :options="enums('Advertiser')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1 mb-2">
                      <b-form-checkbox
                        v-model="Form.IsPublic"
                        name="IsPublic"
                        value="true"
                        class="custom-control-success"
                      >
                        برای همه کاربران نمایش داده شود؟
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>

                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

export default {
  name: 'BannerPositionDetails',
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Position: null,
        Count: null,
        Sorting: null,
        Advertiser: null,
        IsPublic: false,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.bannerposition.add
      if (this.$route.params.id) {
        url = this.$api.bannerposition.update
      }

      if (this.Form.Type === 0) {
        this.Form.Count = 1
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.bannerposition.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>
